/* eslint-disable jsx-a11y/anchor-is-valid */
// TODO: Fix accessibility

import { MouseEvent } from 'react';
import { IMAGES_REPO } from '../../../static-resources';
import { useFindTool } from '../../home/hooks/use-capabilities.hook';
import './insightforecasting.component.scss';

const ProactiveAlertLink = process.env.REACT_APP_ALERTS_PBI;

const handleProactiveAlertClick = (e: MouseEvent<HTMLAnchorElement>) => {
  e.preventDefault();
  const url = ProactiveAlertLink;
  if (url) {
    window.open(url, '_blank');
  } else {
    // TODO: Handle error
  }
};

const InsightForecastingComponent = () => {
  const demandModelTool = useFindTool('Demand Model');
  const decompInsightsModelTool = useFindTool('Decomp Insights');
  const netflowModelTool = useFindTool('Netflow');

  return (
    <>
      <div className="menusub-title">Descriptive Analytics</div>
      <ul className="megamenu-components">
        <li>
          <div className="d-flex navsubmenuitem">
            <div className="w-20">
              <div className="sideicon">
                <img src={IMAGES_REPO.BarChartSquare} alt="" />
              </div>
            </div>
            <div className="w-80">
              <div className="navmenuitem ps-3">
                <h6>
                  <a href={demandModelTool?.href}>Demand Model</a>
                </h6>
                <p>Forecast future sales trends using historical data.</p>
              </div>
            </div>
          </div>
        </li>

        <li>
          <div className="d-flex navsubmenuitem">
            <div className="w-20">
              <div className="sideicon">
                <img src={IMAGES_REPO.LineChartUpActiveIcon} alt="" />
              </div>
            </div>
            <div className="w-80">
              <div className="navmenuitem ps-3">
                <h6>
                  <a href={decompInsightsModelTool?.href}>Decomp Insight</a>
                </h6>
                <p>Analyze sales performance with detailed breakdowns.</p>
              </div>
            </div>
          </div>
        </li>

        <li>
          <div className="d-flex navsubmenuitem">
            <div className="w-20">
              <div className="sideicon">
                <img src={IMAGES_REPO.ProActiveAlertIcon} alt="" />
              </div>
            </div>
            <div className="w-80">
              <div className="navmenuitem ps-3">
                <h6>
                  <a href="#" onClick={handleProactiveAlertClick}>
                    Proactive Alerting
                  </a>
                </h6>
                <p>Learn More about how to create and Manage Alerts.</p>
              </div>
            </div>
          </div>
        </li>

        <li>
          <div className="d-flex navsubmenuitem">
            <div className="w-20">
              <div className="sideicon">
                <img src={IMAGES_REPO.NetFlow} alt="" />
              </div>
            </div>
            <div className="w-80">
              <div className="navmenuitem ps-3">
                <h6>
                  <a href={netflowModelTool?.href}>Netflow</a>
                </h6>
                <p>
                  Understand complex product switching dynamics trained on
                  household loyalty card shopping behavior
                </p>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </>
  );
};
export default InsightForecastingComponent;
